import { Button, Container } from '@playcanvas/pcui';

import { Events } from '../events';
import { localize } from './localization';
import { Tooltips } from './tooltips';
import type { WorkspaceMode } from './workspace-mode';

// The Edit / Render segmented control in the centre of the top bar.
class WorkspaceSwitcher extends Container {
    constructor(events: Events, tooltips: Tooltips, args = {}) {
        args = {
            ...args,
            id: 'workspace-switcher'
        };

        super(args);

        this.dom.setAttribute('role', 'group');
        this.dom.setAttribute('aria-label', localize('workspace.label'));

        const buttons = new Map<WorkspaceMode, Button>();

        const createOption = (mode: WorkspaceMode, text: string, tooltip: string) => {
            const button = new Button({
                class: 'workspace-option',
                text
            });
            button.on('click', () => events.fire('workspace.setMode', mode));
            tooltips.register(button, tooltip, 'bottom');
            buttons.set(mode, button);
            this.append(button);
        };

        createOption('edit', localize('workspace.edit'), localize('tooltip.workspace.edit'));
        createOption('render', localize('workspace.render'), localize('tooltip.workspace.render'));

        const reflect = (mode: WorkspaceMode) => {
            buttons.forEach((button, buttonMode) => {
                const selected = buttonMode === mode;
                button.class[selected ? 'add' : 'remove']('active');
                button.dom.setAttribute('aria-pressed', String(selected));
            });
        };

        events.on('workspace.mode', reflect);
        reflect(events.invoke('workspace.mode'));
    }
}

export { WorkspaceSwitcher };
